import React, { useState } from 'react';
import { getGlobalData } from "../lib/globalData"
import Slider from '../lib/slider';

const Register = props => {
  const [user, setUser] = useState({});
  const { dataprovider, staticel, userinfo, setUserField, is_dev } = props;
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleUserChange = (key) => (ev) => {
    const v = ev.target.value;
    setUser({...user, [key]:v});
  }
  const doneLogin = (res) => {
    if (res.error) {
      setUser(us=>({...us, msg:res.error}));
    }
    else {
//      console.log(res);
      window.location.href = res.info.license>0?'/app#bibliothek':'/app2#shop';
      window.location.reload();
    }
  }
  const doneRecover = (res) => {
    setUser(us=>({...us, msg:res.msg}));
  }
  const handleLogin = (ev) => {
    if (user.email.match(/.+@schulegossau.ch/)) {
      const form = document.createElement("form");
      form.method = "POST";
//      form.action = "https://" + dataprovider.apiUrl + "/saml/saml-test.php";
      form.action = "https://api.soundolino.ch/saml/saml-check.php";

      // Falls du Daten mitgeben musst
      const input1 = document.createElement("input");
      input1.type = "hidden";
      input1.name = "token";
      input1.value = getGlobalData('token');
      form.appendChild(input1);
      const input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "email";
      input2.value = user.email;
      form.appendChild(input2);
      const input4 = document.createElement("input");
      input4.type = "hidden";
      input4.name = "is_dev";
      input4.value = is_dev?1:0;
      form.appendChild(input4);
      document.body.appendChild(form);
      form.submit(); 
    }
    else {
      const data = {...user, front:true,  username:user.email};
      dataprovider.insert('token', data, doneLogin);
    }
  }

  const handleVergessen = (ev) => {
    const data = {...user, front:true,  username:user.email};
    dataprovider.insert('token/recover', data, doneRecover);
  }
  
  const validemail = user.email && re.test(String(user.email).toLowerCase());
  const saml = user.email && user.email.match(/.+@schulegossau.ch/);
  var isValid = true;
  const inValid = {};
  if (!validemail) {
    inValid.email = true;
    isValid = false;
  }
  if (!saml && !user.password) {
    inValid.password = true;
    isValid = false;
  }
  
  if (userinfo.id || user.id) {
    return (
      <>
        <Slider staticel={staticel} page={8} is_dev={is_dev} />
        <div className="container mt-5">
          <div className="row ms-0 mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
            <div className="col">
              <h4>Herzlich Willkommen in der soundolino Community</h4>
            {userinfo.license!==1?
              <p>Du kannst jetzt im <a href="/app#shop">Shop</a> fertige Produkte bestellen, oder eine <a href="/app#shop/s114">Lizenz</a> lösen, um selber Projekte zu gestalten.</p>
            :
              <p>Für dich wurde eine Pauschallizenz aktiviert.<br/><br/>Du kannst jetzt im <a href="/app#shop">Shop</a> fertige Produkte bestellen oder im  <a href="/app#creator">Creator</a> selber Projekte zu gestalten.</p>
            }
            </div>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      <Slider staticel={staticel} page={2} is_dev={is_dev} />
      <div className="container pt-5 mt-5">
        <h2>Anmelden bei soundolino</h2>
    {user.msg &&         
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3 text-end"></div>
          <div className="col-7 col-lg-5">
            <h5 className="text-danger">{user.msg}</h5>
          </div>
        </div>
    }    
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3 text-end">E-Mail</div>
          <div className="col-7 col-lg-5">
            <input type="email" value={user.username} onChange={handleUserChange('email')} className="form-control" />
          </div>
        </div>
    {(!user.email || !saml) &&
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3 text-end">Passwort</div>
          <div className="col-7 col-lg-5">
            <input type="password" value={user.password} onChange={handleUserChange('password')} className="form-control" />
            <div className="invalid-feedback">Min. 8 Zeichen, muss Gross- und Kleinbuchstaben sowie Zahlen enthalten.</div>
          </div>
        </div>
    }
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3"></div>
          <div className="col-3 col-lg-3">
            <button type="button" className={"btn btn-"+(isValid?"primary":"secondary")+" mt-4"}  disabled={!isValid} onClick={handleLogin}>Anmelden {saml?'über Microsoft Konto':''}</button>
          </div>
    {!saml &&
          <div className="col col-4 col-lg-2 text-end">
            <button name="recover" className={"btn btn-"+(validemail?"primary":"secondary")+" mt-4"} disabled={!validemail} onClick={handleVergessen}>Passwort vergessen</button>
          </div>
    }
        </div>
      </div>
    </>
  )
}

export default Register;
